import useFrontendBoot from "@/Hooks/useFrontendBoot";

import usePartnerLogin from "./hooks/usePartnerLogin";
import { FormProvider, useForm } from "react-hook-form";
import { ILoginSchema } from "@/Pages/Login/auth.types";
import { Image, TextInput, ButtonBase } from "@repo/ui/index.tsx";
import { RGX_email } from "@/utility/regexs";
import { ArrowLongRightIcon } from "@heroicons/react/24/outline";
import useAuthentication from "@/Hooks/useAuthentication";
import { Helmet } from "react-helmet-async";

function PartnerLoginPage() {
  useAuthentication();
  const {
    mutations: { loginMutation },
    functions: { handlePartnerLogin },
  } = usePartnerLogin();

  const { logo, partnerFrontendBootService } = useFrontendBoot();
  const partnerFrontendBootData = partnerFrontendBootService?.data?.data || {};
  const formData = useForm<ILoginSchema>();

  // Function to handle form submission
  const onSubmitHandler = (data: ILoginSchema) => {
    handlePartnerLogin({ ...data, device_name: "web" });
  };

  return (
    <div
      id="pattern_banknote"
      className="h-screen w-full flex  justify-center "
    >
      {partnerFrontendBootData && (
        <Helmet>
          <link
            rel="icon"
            type="image/svg+xml"
            href={partnerFrontendBootData?.favicon?.original_url}
          />
          <title>{partnerFrontendBootData?.meta_title}</title>
          <meta
            name="description"
            content={partnerFrontendBootData?.meta_description}
          />
        </Helmet>
      )}
      <section className=" flex-1 flex items-center justify-center h-full w-full  bg-gradient-to-br from-primary/20 via-transparent to-transparent">
        <div className="flex flex-col text-subheading gap-4 w-10/12">
          <h1 className="font-semibold text-3xl leading-tight">
            <span>Welcome to </span>
            <span className="border-b-4 border-body">
              Affinity Insurance
            </span>{" "}
            <br />
            <span className="font-black text-[4rem] italic text-primary">
              Partner Portal
            </span>
          </h1>

          <p className=" w-8/12 font-medium text-wrap">
            Here, you can manage your partnership, access exclusive resources,
            and streamline your operations with ease. We are committed to
            supporting our partners with comprehensive tools and dedicated
            support to ensure your success.
          </p>
        </div>
      </section>
      <section className="w-2/5 h-full flex justify-center items-center rounded-l-xl shadow-xl bg-white">
        <FormProvider {...formData}>
          <form
            onSubmit={formData.handleSubmit(onSubmitHandler)}
            className="w-96 flex flex-col gap-4"
          >
            {logo ? (
              <Image
                src={logo}
                alt="company logo"
                className="w-56 max-h-24 p-3 object-contain border-2 border-primary/10 rounded-lg"
              />
            ) : (
              <div className="h-[3.5rem] rounded-lg w-[10rem] bg-extraLightGray animate-pulse" />
            )}

            <h2 className="text-lg font-semibold">Welcome back!</h2>
            <TextInput
              name="email"
              type="text"
              placeholder="Enter email..."
              label="Email Address"
              registerOptions={{
                required: "Email is required",
                pattern: {
                  value: RGX_email,
                  message: "Invalid email address",
                },
              }}
            />
            <TextInput
              name="password"
              type="password"
              placeholder="Enter password..."
              label="Password"
              registerOptions={{
                required: "Password is required",
              }}
              {...(!import.meta.env.DEV && {
                disablePaste: true,
              })}
              disableCopy
            />
            <ButtonBase
              buttonType="tertiary"
              text="Forgot password!"
              className="text-primary text-sm self-end w-32"
            />

            <ButtonBase
              type="submit"
              text="Login"
              buttonType="primary"
              icon={<ArrowLongRightIcon className="w-8" />}
              isLoading={loginMutation.isPending}
            />
          </form>
        </FormProvider>
      </section>
    </div>
  );
}

export default PartnerLoginPage;
